import { useMemo } from 'react';
import { BrowserFormatter } from '@sas/nova-core/i18n/formatting/BrowserFormatter';
import { useLanguage } from '../useTextLocalizer';
export { BrowserFormatter } from '@sas/nova-core/i18n/formatting/BrowserFormatter';

/**
 * @param locale locale to pass to the formatter. Defaults to application language.
 * @returns An instance of BrowserFormatter for the locale.
 */
export const useBrowserFormatter = locale => {
  const language = useLanguage();
  const preferredLocale = locale ?? language;
  const formatter = useMemo(() => {
    return new BrowserFormatter(preferredLocale);
  }, [preferredLocale]);
  return formatter;
};
//# sourceMappingURL=BrowserFormatter.js.map